import { render, staticRenderFns } from "./home.html?vue&type=template&id=51b38056&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "./home.scss?vue&type=style&index=0&id=51b38056&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b38056",
  null
  
)

export default component.exports